import React, { useState } from "react";
import { InputFieldLogin } from "./InputField";
const PasswordResetForm = ({
  email,
  setEmail,
  requestRetrievePassword,
  setShowPasswordResetForm,
  setEmailSelectedLogin,
  emailSelectedLogin,
}) => {
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await requestRetrievePassword(email);
      setMessage("Password reset link sent. Check your email.");
      setError(null);
    } catch (error) {
      setMessage(null);
      setError("Error sending password reset link.");
    }
  };

  return (
    <div className="w-full h-full">
      <div className="mt-20 sm:mt-0 flex flex-col justify-center items-center h-[30rem] sm:h-[35rem]">
        <form
          onSubmit={handleSubmit}
          className="p-8 -mt-10 rounded-lg shadow-md w-full max-w-md bg-white"
        >
          <h1 className="text-3xl font-bold text-gray-600">Reset Password</h1>

          <InputFieldLogin
            id="email"
            type="text"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onFocus={() => setEmailSelectedLogin(true)}
            onBlur={() => setEmailSelectedLogin(false)}
            selected={emailSelectedLogin}
            label="Email"
          />
          {message && <p className="text-green-500">{message}</p>}
          {error && <p className="text-red-500">{error}</p>}
          <button
            type="submit"
            className="mt-5 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full"
          >
            Send Reset Link
          </button>
          <button
            type="button"
            onClick={() => setShowPasswordResetForm(false)}
            className="mt-5 text-blue-600 hover:underline"
          >
            Back to Login
          </button>
        </form>
      </div>
    </div>
  );
};

export default PasswordResetForm;
